import type { ReactNode } from 'react';

interface WalletSlotProps {
  /** Brand id used for `data-testid="wallet-slot-${brand}"`. */
  brand: 'apple' | 'google';
  /** Wallet-specific button placeholder (Apple Pay / Google Pay). */
  placeholder: ReactNode;
  /** Collapses the slot vertically; mirrors what Stripe ECE reported. */
  isCollapsed: boolean;
  /** Hide the loading overlay once the wallet (or the pair) is ready. */
  isReady: boolean;
  /** aria-label for the spinner role="status" — localized by caller. */
  loadingLabel: string;
}

/**
 * One brand-styled placeholder + loader overlay slot inside the
 * `wallet-pair` row. Extracted so the Apple Pay / Google Pay halves of
 * the express row stop being copy-pasted (~9 lines × 2). The slot is
 * intentionally markup-only — collapse + ready state come from the
 * parent because `wallet-pair` coordinates both halves at once.
 */
export const WalletSlot = ({ brand, placeholder, isCollapsed, isReady, loadingLabel }: WalletSlotProps) => (
  <div className={`wallet-collapse${isCollapsed ? ' is-collapsed' : ''}`}>
    <div className="wallet-slot" data-testid={`wallet-slot-${brand}`}>
      {placeholder}
      <div className="wallet-slot__overlay" aria-hidden={isReady || isCollapsed ? 'true' : undefined}>
        <span className="wallet-btn__spinner" role="status" aria-label={loadingLabel} />
      </div>
    </div>
  </div>
);
